import { render, staticRenderFns } from "./ProfileNotificationCenter.vue?vue&type=template&id=7c08f77f&scoped=true&"
import script from "./ProfileNotificationCenter.vue?vue&type=script&lang=js&"
export * from "./ProfileNotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNotificationCenter.vue?vue&type=style&index=0&id=7c08f77f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08f77f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
